import { render, staticRenderFns } from "./UserArchiveTable.vue?vue&type=template&id=30d812ea&scoped=true&"
import script from "./UserArchiveTable.vue?vue&type=script&lang=ts&"
export * from "./UserArchiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserArchiveTable.vue?vue&type=style&index=0&id=30d812ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d812ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VDivider,VSnackbar,VTextField})
